import * as go from "gojs";

export const workflowEditorConstants = {
  grid: {
    rows: 20,
    cols: 20
  },
  nodeSize: 200
};

export const $ = go.GraphObject.make;
